import axios from '@/plugins/axios.js';

const moduleHome = {
	namespaced: true,
	state: {
		ART_SUBMIT_ENABLE: '',
    COS_SUBMIT_ENABLE: '',
    LCOS_SUBMIT_ENABLE: '',
    
    ART_LIKES_ENABLE: '',
    COS_LIKES_ENABLE: '',
    LCOS_LIKES_ENABLE: '',

    ART_SHOW_ENABLE: '',
    COS_SHOW_ENABLE: '',
    LCOS_SHOW_ENABLE: '',

    COMMENT_ENABLE: true
	},
	mutations: {
    SET_CONFIG: (state, config) => {
      state.ART_SUBMIT_ENABLE = config.a.submitEnable
      state.ART_LIKES_ENABLE = config.a.likeEnable
      state.ART_SHOW_ENABLE = config.a.showEnable

      state.COS_SUBMIT_ENABLE = config.c.submitEnable
      state.COS_LIKES_ENABLE = config.c.likeEnable
      state.COS_SHOW_ENABLE = config.c.showEnable

      state.LCOS_SUBMIT_ENABLE = config.l.submitEnable
      state.LCOS_LIKES_ENABLE = config.l.likeEnable
      state.LCOS_SHOW_ENABLE = config.l.showEnable

      state.COMMENT_ENABLE = config.commentEnable
    }
	},
	actions: {
    async getConfig({ commit }) {
      try {
        const config = await axios.get('/works/config')
        if(config) {
          commit("SET_CONFIG", config)
        }
      } catch (error) {
        console.log(error)
      }
    },
    daq(_, data) {
      axios.post("/works/daq", data)
    }
  },
	getters: {},
}

export default moduleHome
